import styled from "styled-components";

export const Container = styled.div`
  /* max-width: 900px; */
  margin: 2em clamp(0.1em, 8vw, 300px);

  @media (max-width: 576px) {
    margin: 0 0.8em;
  }
`;

export const Title = styled.h1`

  font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};`;

export const Content = styled.div`
  position: relative;
`;

export const ShapeTopRight = styled.div`
  position: absolute;
  /* background-color: #c39442; */
  /* border-radius: 8px; */
  top: -30px;
  right: 10px;
  object-fit: contain;
  /* right: auto; */
  /* left: auto; */

  img {
    width: 80px;
    height: 80px;
  }
  @media (max-width: 768px) {
  }
`;

export const Description = styled.div`
  width: 100%;
  border-radius: 16px;
  margin: 2em auto;
  overflow: visible;
  background-color: #ca37aa13;
  border: 0.5px solid #5c0630;
  direction: ${(props) =>
    props.lang === "fa" ? "right" : "left"};
  
  p {
    padding: 2em;
    /* padding-right: 200px; */
    font-size: 1rem;
    color: #4a5d58;
    line-height: 1.5;
  }

  ul {
    list-style: none;
    padding-left: 0;
    padding: 1rem 0;
    /* margin-bottom: auto; */
  }

  li {
    display: flex;
    align-items: center;
  }

  li span {
    margin-left: ${(props) => props.lang === "en" ? "0" : "10px"};
    margin-right: ${(props) => props.lang === "en" ? "0" : "10px"};
    color: #333;
    font-weight: bold;
  }
  @media (max-width: 576px) {
    margin: 0.5em auto;
    p {
      padding: 1em;
    }
  }
`;

export const PricingTable = styled.div`
  margin: 20px auto;
  border-collapse: collapse;
  text-align: center;
  /* background-color: red; */
  /* border-radius: 100%; */

`;

// export const Header = styled.div`
//   margin-bottom: 25px;
//   font-size: 18px;
//   font-weight: 600;
//   color: #444;
//   text-align: left;
// `;

export const HeaderCell = styled.th`
  padding: 10px;
  border-bottom: 1px solid #030303;
  font-size: clamp(16px, 1.5vw, 33em);
  font-weight: bold;
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
`;

export const Row = styled.tr`
  &:nth-child(odd) {
    background-color: #f9f9f9;
  }
  &:last-child {
    /* background-color: red; */
    td {
      border-top: 1px solid #000;
      font-weight: 900;
      font-size: clamp(16px, 1.7vw, 33em);
    }
    border-bottom: 2px solid #000;
  }
`;

export const HeaderRow = styled.tr`
  background-color: #f5f5f5;
  border-radius: 100px;
`;

export const Cell = styled.td`
  padding: 5px 0.7em;
  font-size: clamp(13px, 1.6vw, 33em);
  
  &:first-child {
    // background-color: red;
    text-align: ${(props) => props.lang === "en" ? "left" : "right"};
  }
  span {
    font-size: 12px;
    color: #888;
    display: block;
  }
`;
